import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("h3", { class: "mb-3 mb-lg-4" }, "Spline Area", -1)),
      _cache[1] || (_cache[1] = _createElementVNode("div", { id: "spline_area" }, null, -1)),
      (_ctx.isClient)
        ? (_openBlock(), _createBlock(_component_apexchart, {
            key: 0,
            type: "area",
            height: "350",
            options: _ctx.splineArea,
            series: _ctx.spline
          }, null, 8, ["options", "series"]))
        : _createCommentVNode("", true)
    ])
  ]))
}